import { Action } from '@ngrx/store';

export const ACTIVAR_OPCIONDM = '[PANEL_DATOS] ActivarOpcionDM';


export class ActivarOpcionDMAction implements Action {
  readonly type = ACTIVAR_OPCIONDM;
  constructor(public opcion: string ) {}
}

export type OpcionDMActions =
  | ActivarOpcionDMAction;
